import React from "react";
import NHeader from "../NHeader";
import NavigatorMain from "../NavigatorMain";
import Util,{ToastTime} from "../../util";
import PositionList from "../PositionList";
import {hashHistory} from 'react-router'
import './positiondetails.css'
import { Toast } from 'antd-mobile/lib';
class PositionDetails extends React.Component{
  constructor(props){
    super(props)
  }
  componentDidMount(){
    document.title= "持仓明细";
  }
  toPublicOffering = (item) => {
    if (item.camcOrNonCamcWhiteListFundFlag === "0") return Toast.info("该产品暂不支持交易", ToastTime);
    hashHistory.push({ pathname: "/PublicOffering", query: { fundCode: item.fundCode }, state: { fundCode: item.fundCode } });
  };
  renderItem = (item) => (
    <div key={item.fundCode} className="PD_list_item" onClick={()=>{this.toPublicOffering(item)}} >
      <span>{item.fundName}</span>
      <span>{item.fundCode}</span>
    </div>
  );
  header = (v) => (
    <div className="PD_Pie_header" style={{ background: Util.pieEchartsFundListColorMap.get(v.styleTypeName) }}>
      <span className="PD_Pie_title">{v.styleTypeName}</span>
      <span className="PD_pie_totlevalue" >{Util.toPercent(v.totalRate)}</span>
    </div>
  );
  render(){
    const {superFundItemFund4StyleTypeList=[],updateTimeStr}=this.props.location.state
    return (
      <div className="PD_container" style={{minHeight: window.winHeight,background:`#fff url(${require('../../img/n_icon_header_bg@2x.png')}) no-repeat 0 0/100% auto`}}>
        <NavigatorMain>
          <NHeader title="持仓明细"/>
        </NavigatorMain>
        
        <div className="PD_list">
          <div className="PD_list_header">
            <span className="PD_list_title">策略持仓</span>
            <span>更新时间：{updateTimeStr}</span>
          </div>
          {superFundItemFund4StyleTypeList.map((v, i) => (
            <PositionList key={i} background={Util.pieEchartsFundListBgColorMap.get(v.styleTypeName)} header={this.header(v)} renderItem={this.renderItem} dataSource={v.subSuperFundItemList} topDistance=".22rem" bottomDistance=".22rem" />
          ))}
        </div>
      </div>
    )
  }
}

export default PositionDetails


// WEBPACK FOOTER //
// ./src/components/fundDetail/PositionDetails.js